"use client";

import { type LucideIcon } from "lucide-react";

import { SidebarGroup, SidebarGroupLabel, SidebarMenu } from "@/lib/shadcn/ui/sidebar";
import { NavItem } from "@/lib/shadcn/components/sidebar/nav-item";

export interface NavSubItem {
    title: string;
    url: string;
    /** Optional live count rendered as a small badge after the title (e.g. re-file queue size). */
    badgeCount?: number;
    /**
     * Screen-reader-only wording for what `badgeCount` counts ("wedged", "pending").
     * Never shown — the badge stays a bare number visually. Defaults to "pending".
     */
    badgeLabel?: string;
}

export interface NavSection {
    title: string;
    items: {
        title: string;
        url: string;
        icon?: LucideIcon;
        isActive?: boolean;
        items?: NavSubItem[];
    }[];
}

export interface NavPlatformProps {
    sections: NavSection[];
}

export const NavPlatform: React.FC<NavPlatformProps> = ({ sections }) => {
    return (
        <>
            {sections.map((section) => (
                <SidebarGroup key={section.title}>
                    <SidebarGroupLabel>{section.title}</SidebarGroupLabel>
                    <SidebarMenu>
                        {section.items.map((item) => (
                            <NavItem key={item.title} {...item} />
                        ))}
                    </SidebarMenu>
                </SidebarGroup>
            ))}
        </>
    );
};
